import { render, staticRenderFns } from "./widgetFwDenyTop10.vue?vue&type=template&id=601287f6&scoped=true&"
import script from "./widgetFwDenyTop10.vue?vue&type=script&lang=js&"
export * from "./widgetFwDenyTop10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601287f6",
  null
  
)

export default component.exports